/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DescriptionLabel/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DescriptionLabel({
  children,
  viewPath = "/DesignSystem/DescriptionLabel",
  alignItems = "flex-end"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DescriptionLabel.Vertical"
  data-view-path={viewPath}
 style={{'--ai-1-ZpxqDB': alignItems}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}